<template>
    <div>

        <div class="my-6 flex items-center">
            <span class="inline-block mr-6">Select a date: </span>
            <select class="form-input my-0" name="month" v-model="selectedMonth">
                <option v-for="i in 12" :value="i - 1">{{ showMonthName(i - 1) }}</option>
            </select>
            <span class="inline-block mx-2">/</span>
            <select class="form-input my-0" name="year" v-model="selectedYear">
                <option v-for="i in yearSelect" :value="i">{{i}}</option>
            </select>

            <button @click="selectDate(-1)" class="btn btn-info ml-6" style="min-width: 2.8rem;">-</button>
            <button @click="selectDate(1)" class="btn btn-info ml-6" style="min-width: 2.8rem;">+</button>

            <button v-if="!notAvailable" @click="saveMarktime" class="btn btn-secondary ml-6">
                <div v-if="saving" class="loader"></div>
                <span v-else>Save</span>
            </button>
        </div>


        
        <div v-if="init">
			<div v-if="!notAvailable">
                <div class="flex">
                    <div class="mr-6">
                        <MarktimeTable :marktime="marktime" :setup="date"></MarktimeTable>
                    </div>
                    <div class="">
                        <MarktimeTableOverview :marktime="marktime"></MarktimeTableOverview>
                    </div>
                </div>
            </div>
            <div v-else>
                There is already existing marktime for this selected date.
            </div>
		</div>

        <div v-else class="loader loader-dark loader-big ml-4 mt-4 mr-0 mb-0"></div>


        <SimpleModal v-if="unsavedModal" @action="saveMarktime" @close="$store.commit('SET_UNSAVED_MODAL', false)" :btnClass="'btn-secondary'">
            <template v-slot:title>Unsaved changes</template>
            <template v-slot:body>You have unsaved changes!</template>
            <template v-slot:cancel>Close</template>
            <template v-slot:button>Save</template>
            <template v-slot:customButton>
                <button class="btn btn-info ml-4" @click="discardChanges">
                    Discard changes
                </button>
            </template>
        </SimpleModal>
        

    </div>
</template>

<script>
import moment from 'moment';
import { db } from '@/firebase'
import { mapState } from 'vuex'
import store from '@/store/store'

import MarktimeTable from '@/components/MarktimeTable.vue';
import MarktimeTableOverview from '@/components/MarktimeTableOverview.vue';
import SimpleModal from '@/components/SimpleModal.vue'

var Holidays = require('date-holidays')
var hd = new Holidays('CZ')

export default {
    data() {
        return {
            date: {
                year: new Date().getFullYear(),
                month: new Date().getMonth()
            },
            saving: 0,
            marktime: null
        }
    },
    
    computed: {

        selectedYear: {
            get() {
                return this.date.year
            },
            set(value) {
                var time = moment({
                    year: value,
                    month: this.selectedMonth
                })
                this.date.month = time.month()
                this.date.year = time.year()
                this.createMarktime()
            }
        },

        selectedMonth: {
            get() {
                return this.date.month
            },
            set(value) {
                var time = moment({
                    year: this.selectedYear,
                    month: value
                })
                this.date.month = time.month()
                this.date.year = time.year()
                this.createMarktime()
            }
        },


        init() {
            if (this.currentUser && this.currentUserMarktimes && this.currentUserVacations) {
                return true
            }
            return false
        },

        ...mapState({
			currentUser: state => state.user.info,
			currentUserMarktimes: state => state.user.marktimes,
			currentUserVacations: state => state.user.vacations,
			unsaved: state => state.unsaved,
			unsavedModal: state => state.unsavedModal,
		}),

        notAvailable() {

            if (this.init) {
                var marktime = this.currentUserMarktimes.find(marktime => {
                    return (marktime.year == this.date.year && marktime.month == this.date.month)
                })
                if (marktime) return true
            }
            return false

        },

        yearSelect() {
            var yearArray = []
            for (var i = this.date.year - 5; i <= this.date.year + 3; i++) {
                yearArray.push(i)
            }
            return yearArray;
        }
        
    },

    components: {
        MarktimeTable,
        MarktimeTableOverview,
        SimpleModal
    },

    methods: {
        isSunday(day) {
            var date = moment({
                year: this.date.year,
                month: this.date.month,
                day: day + 1
            })
            return date.day() == 0;
        },
        
        isSaturday(day) {
            var date = moment({
                year: this.date.year,
                month: this.date.month,
                day: day + 1
            })
            return date.day() == 6;
        },

        isHoliday(day) {
            var holiday = hd.isHoliday(
                new Date(
                    moment({
                        year: this.date.year,
                        month: this.date.month,
                        day: day + 1
                    })
                )
            )

            if (holiday) {
                if (holiday.type === 'public') return true
            }

            return false
        },

        saveMarktime() {
            this.saving = 1;

            db
                .collection('marktimes')
                .add(this.marktime)
                .then((ref) => {
                    this.saving = 0;

                    this.$store.commit('SET_UNSAVED_MODAL', false);
                    this.$store.commit('SET_UNSAVED', false);
                    this.$store.commit('config/SET_ROUTE', null);

                    this.$router.replace({
                        name: 'marktime-edit',
                        params: {
                            id: ref.id
                        }
                    })
                    this.$toasted.show(`Saved successfully!`, {
                        type: 'success'
                    })
                })
                .catch((error) => {
                    this.$toasted.show(`Error: ${error}`, {
                        type: 'error'
                    })
                })
            
        },

        getTimeFrom(i) {
            return new Date(this.getMomentDate(i))
        },

        getTimeTo(i) {
            var workTime = (this.currentUser.isPartTime) ? this.currentUser.partTime + 0.5 : 8.5
            return  new Date(this.getMomentDate(i).add(workTime, 'h'))
        },

        getMomentDate(i) {
            return moment({
                year: this.date.year,
                month: this.date.month,
                day: i + 1,
                hour: this.currentUser.hourFrom,
                minute: this.currentUser.minFrom
            })
        },

        showMonthName(i) {
            return moment({
                month: i
            }).format('MMMM')
        },

        selectDate(add) {

            var time = moment({
                year: this.date.year,
                month: this.date.month
            })

            time.add(add, 'months')
            this.date.month = time.month()
            this.date.year = time.year()
            this.createMarktime()
        },

        createMarktime() {

            if (this.currentUser && this.currentUserVacations) {
                let marktimeArray = [];
                var numberOfDaysInMonth = moment({
                    year: this.date.year,
                    month: this.date.month
                }).daysInMonth()
                //console.log(numberOfDaysInMonth, 'numberOfDaysInMonth');
                for (let i = 0; i < numberOfDaysInMonth; i++) {

                    var vacationRanges = this.currentUserVacations.map(vacation => {
                        return {
                            startDate: new Date(vacation.from.seconds * 1000),
                            endDate: new Date(vacation.to.seconds * 1000)
                        }
                    })

                    var isVacation = vacationRanges.find(vacation => {

                        var today = moment({
                            year: this.date.year,
                            month: this.date.month,
                            day: i + 1
                        });

                        return today.isBetween(moment(vacation.startDate), moment(vacation.endDate), 'day', '[]');
                    })


                    if (isVacation && !this.isHoliday(i) && !this.isSaturday(i) && !this.isSunday(i)) {
                        marktimeArray.push({
                            type: 'D',
                            timeFrom: null,
                            timeTo: null,
                            overtime: null,
                            halfday: null
                        });
                        continue;
                    }

                    marktimeArray.push({
                        type: (this.isHoliday(i) && !this.isSaturday(i) && !this.isSunday(i)) ? 'S' : '0',
                        timeFrom: (this.isSaturday(i) || this.isSunday(i) || this.isHoliday(i)) ? null : this.getTimeFrom(i),
                        timeTo: (this.isSaturday(i) || this.isSunday(i) || this.isHoliday(i)) ? null : this.getTimeTo(i),
                        overtime: null,
                        halfday: null
                    })


                }
                
                this.marktime =  {
                    year: this.date.year,
                    month: this.date.month,
                    marktime: marktimeArray,
                    user: this.currentUser.uid
                };
            }
        },

        discardChanges() {
            this.$store.commit('SET_UNSAVED_MODAL', false);
            this.$store.commit('SET_UNSAVED', false);
            if (this.$store.state.config.routeTo) {
				this.$router.replace({
					name: this.$store.state.config.routeTo
				})
			}
            this.$store.commit('config/SET_ROUTE', null);
        }
    },

    async created() {

        if (!this.currentUser) await this.$store.dispatch('user/getUser');
        if (!this.currentUserMarktimes) await this.$store.dispatch('user/getMarktimes');
        if (!this.currentUserVacations) await this.$store.dispatch('user/getVacations');

        this.createMarktime();

        this.$store.commit('SET_TITLE', 'Add new marktime');

    },

    beforeRouteLeave: (to, from, next) => {
        if (store.state.unsaved) {
            store.commit('SET_UNSAVED_MODAL', true);
            store.commit('config/SET_ROUTE', to.name);
        } else {
            next();
        }
    }
}
</script>

